import { render, staticRenderFns } from "./the-effect-of-oil-spills.vue?vue&type=template&id=7458d80c&"
import script from "./the-effect-of-oil-spills.vue?vue&type=script&lang=js&"
export * from "./the-effect-of-oil-spills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports